/** Dashboard defaults requested for the test/admin accounts; API callers default to no exclusions. */
export const DEFAULT_EXCLUDED_STAFF = [
  { user_id: 66, name: 'Systems Administrator' },
  { user_id: 178, name: 'NeilStaff Sharman' },
  { user_id: 111, name: 'Stafford Memberous' },
  { user_id: 2761, name: 'Test Accounts' }
] as const;

export function defaultExcludedStaffIds(): number[] { return DEFAULT_EXCLUDED_STAFF.map(staff => staff.user_id); }

export interface StaffExclusionContext {
  /** Optional so historical snapshots keep their captured population. */
  staff_exclusions?: { version: 1; user_ids: number[] };
}

export function staffExclusionsMatch(context: StaffExclusionContext, search: { excluded_staff_ids?: Array<number | string> }): boolean {
  const requested = Array.from(new Set((search.excluded_staff_ids || []).map(Number))).sort((a, b) => a - b);
  if (!requested.length) { return !context?.staff_exclusions?.user_ids?.length; }
  const applied = context?.staff_exclusions;
  return applied?.version === 1 && Array.isArray(applied.user_ids) &&
    JSON.stringify(requested) === JSON.stringify(Array.from(new Set(applied.user_ids)).sort((a, b) => a - b));
}

export const STAFF_EXCLUSIONS_UPDATE_MESSAGE = 'Staff exclusions require the updated reporting API. Upload the development reporting files and refresh.';
